import { FC } from "react";
import { t } from "i18next";
import { FieldArrayWithId, UseFieldArrayRemove, useFormContext } from "react-hook-form";

// Services and interfaces
import { IRecipe } from "@/interfaces/recipe/recipe";

// Styles
import { TrashCan } from "@carbon/icons-react";

// Components
import { Box } from "@mui/material";
import TextInput from "@/components/text_input";
import IconButton from "@/components/icon_button";


interface _InstructionsBuilderProps {
    fields: FieldArrayWithId<IRecipe, "instructions", "id">[];
    readonly: boolean;
    remove: UseFieldArrayRemove;
}

const InstructionsBuilder: FC<_InstructionsBuilderProps> = ({
    fields,
    readonly,
    remove
}) => {

    const { control } = useFormContext<IRecipe>();

    return (
        <Box>
            {fields.length == 0 && (
                <Box className='body-02-compact text-secondary' py={5} textAlign='center'>
                    {t('components.recipeBuilder.noInstructions')}
                </Box>
            )}

            {fields.map((f, i) => (
                <Box key={f.id} pt={2} display='flex' gap={1} alignItems='center'>
                    <TextInput 
                        name={`instructions.${i}.instruction`}
                        control={control}
                        label={t('components.recipeBuilder.step', { count: f.step })}
                        size="textarea"
                        autoResize
                        minRows={4}
                        maxLength={2000}
                        disabled={readonly}
                    />
                    <IconButton 
                        size='small'
                        kind='danger-ghost'
                        icon={<TrashCan />}
                        disabled={readonly}
                        onClick={() => remove(i)}
                    />
                </Box>
            ))}
        </Box>
    )
}

export default InstructionsBuilder;